var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spars-list"},[_c('ul',_vm._l((_vm.spars),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.onSparSelect(item)}}},[_c('img',{staticClass:"spar-icon",attrs:{"src":item.src,"alt":item.name}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }